import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

import './pagination.scss';

const Pagination = ({ paginationData, navigateTo }) => {
  return (
    <div className="py-4 flex gap-4 items-center justify-end">
      <span>{`Page ${paginationData?.currentPage || ''}`}</span>
      <div className="flex items-center gap-2">
        <Button
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-10 px-4 py-2 bg-indigo-600 hover:bg-indigo-700"
          variant="contained"
          color="primary"
          disabled={!paginationData?.prevPage}
          onClick={() => navigateTo(paginationData?.prevPage)}
        >
          {'<'}
        </Button>
        <Button
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-10 px-4 py-2 bg-indigo-600 hover:bg-indigo-700"
          variant="contained"
          color="primary"
          disabled={!paginationData?.nextPage}
          onClick={() => navigateTo(paginationData?.nextPage)}
        >
          {'>'}
        </Button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  navigateTo: PropTypes.func,
};

export default Pagination;
